import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import { Button } from '../components/common/Button';
import { useAuth } from '../hooks/useAuth';

export default function TermsOfUse() {
  usePageTitle('Termos de uso');
  const { isAuthenticated } = useAuth();
  return (
    <div className="landing-container">
      <header className="landing-header">
        <div className="landing-nav">
          <Link to="/" className="landing-logo" style={{ textDecoration: 'none' }}>
            <img src="/logo.png" alt="Lictor" className="landing-logo-icon" style={{ width: 48, height: 48 }} />
            <span>Lictor</span>
          </Link>
          <div className="landing-nav-ctas">
            {isAuthenticated ? (
              <Link to="/dashboard">
                <Button variant="primary" size="sm">Acessar Painel</Button>
              </Link>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="ghost" size="sm">Entrar</Button>
                </Link>
                <Link to="/register">
                  <Button variant="primary" size="sm">Criar Conta</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <main style={{ padding: 'var(--space-12) var(--space-8)', maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ fontSize: 'var(--text-3xl)', marginBottom: 'var(--space-8)', color: 'var(--color-text-primary)' }}>
          Termos de Uso
        </h1>

        <div style={{ color: 'var(--color-text-secondary)', lineHeight: 1.6, display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
          <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

          <h2 style={{ color: 'var(--color-text-primary)', marginTop: 'var(--space-6)', fontSize: 'var(--text-xl)' }}>1. Aceitação dos Termos</h2>
          <p>
            Ao acessar e usar o Lictor ("Serviço"), você concorda em cumprir e ficar vinculado a estes Termos de Uso.
            O Lictor é uma plataforma projetada para atuar como centralizador de credenciais de acesso aos sistemas e tribunais.
          </p>

          <h2 style={{ color: 'var(--color-text-primary)', marginTop: 'var(--space-6)', fontSize: 'var(--text-xl)' }}>2. Descrição do Serviço e Restrições</h2>
          <p>
            O Serviço permite o armazenamento seguro e o compartilhamento controlado de credenciais (login, senha e segredos TOTP).
            <strong>Aviso importante sobre 2FA:</strong> Atualmente, o Lictor não possui suporte para interceptação ou gerenciamento de códigos de Autenticação de Dois Fatores (2FA) que são enviados para endereços de e-mail ou SMS. O suporte para 2FA restringe-se a tokens baseados em tempo (TOTP).
          </p>

          <h2 style={{ color: 'var(--color-text-primary)', marginTop: 'var(--space-6)', fontSize: 'var(--text-xl)' }}>3. Recomendações de Segurança (Importante)</h2>
          <div style={{ background: 'var(--color-bg-surface)', padding: 'var(--space-4)', borderRadius: 'var(--radius-md)', borderLeft: '4px solid #f59e0b' }}>
            <p style={{ margin: 0, marginBottom: 'var(--space-3)' }}>
              <strong style={{ color: '#f59e0b' }}>⚠ Desativação Obrigatória do Salva-Senhas do Navegador:</strong>
            </p>
            <p style={{ margin: 0, marginBottom: 'var(--space-3)' }}>
              Para evitar conflitos, problemas de preenchimento incorreto e garantir a máxima segurança dos seus dados, é <strong>fortemente recomendado que você desative o recurso de salvar senhas automaticamente no seu navegador web</strong> (Chrome, Edge, Firefox, etc.). O Lictor deve ser a única fonte da verdade para suas credenciais de acesso aos tribunais.
            </p>
            <p style={{ margin: 0, marginBottom: 'var(--space-3)', fontSize: 'var(--text-sm)' }}>
              <strong style={{ color: 'var(--color-text-primary)' }}>Riscos de manter o salva-senhas do navegador ativo:</strong>
            </p>
            <ul style={{ margin: 0, paddingLeft: 'var(--space-5)', display: 'flex', flexDirection: 'column', gap: 'var(--space-1)', fontSize: 'var(--text-sm)', listStyle: 'disc' }}>
              <li>Preenchimento com senhas antigas/desatualizadas, causando bloqueio de conta nos tribunais</li>
              <li>Conflito entre o preenchimento do navegador e da extensão Lictor</li>
              <li>Armazenamento de senhas em local inseguro (o navegador não possui a mesma proteção que o Lictor)</li>
              <li>Múltiplas fontes de verdade para a mesma credencial, gerando confusão</li>
            </ul>
            <div style={{ marginTop: 'var(--space-4)', display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
              <p style={{ margin: 0, fontSize: 'var(--text-sm)' }}>
                <strong style={{ color: 'var(--color-text-primary)' }}>Como desativar:</strong>
              </p>
              <p style={{ margin: 0, fontSize: 'var(--text-sm)' }}>
                <strong>Chrome/Edge:</strong> Configurações → Senhas e preenchimento automático → Gerenciador de senhas → Desative "Oferecer para salvar senhas" e "Login automático".
              </p>
              <p style={{ margin: 0, fontSize: 'var(--text-sm)' }}>
                <strong>Firefox:</strong> Configurações → Privacidade e Segurança → Credenciais → Desmarque "Pedir para salvar credenciais de acesso a sites".
              </p>
            </div>
          </div>

          <h2 style={{ color: 'var(--color-text-primary)', marginTop: 'var(--space-6)', fontSize: 'var(--text-xl)' }}>4. Boas Práticas de Uso</h2>
          <div style={{ background: 'var(--color-bg-surface)', padding: 'var(--space-4)', borderRadius: 'var(--radius-md)', borderLeft: '4px solid var(--color-primary-500)' }}>
            <p style={{ margin: 0, marginBottom: 'var(--space-3)' }}>
              <strong style={{ color: 'var(--color-primary-400)' }}>Crie uma credencial por URL/sistema:</strong>
            </p>
            <p style={{ margin: 0, fontSize: 'var(--text-sm)' }}>
              Para o melhor funcionamento do preenchimento automático pela extensão do navegador, recomendamos que cada credencial seja associada a um único sistema/URL. Isso permite que o popup de preenchimento automático identifique corretamente cada sistema e evite ambiguidades.
            </p>
          </div>

          <h2 style={{ color: 'var(--color-text-primary)', marginTop: 'var(--space-6)', fontSize: 'var(--text-xl)' }}>5. Responsabilidades do Usuário</h2>
          <p>
            Você é responsável por manter a confidencialidade das credenciais de acesso à sua conta mestre do Lictor. Qualquer atividade realizada sob sua conta é de sua inteira responsabilidade.
            Garantimos a segurança da nossa infraestrutura, porém a segurança do dispositivo final (seu computador) também é crucial.
          </p>

          <h2 style={{ color: 'var(--color-text-primary)', marginTop: 'var(--space-6)', fontSize: 'var(--text-xl)' }}>6. Modificações do Serviço e dos Termos</h2>
          <p>
            Reservamo-nos o direito de modificar ou descontinuar o Serviço (ou qualquer parte dele) a qualquer momento. Também podemos atualizar estes Termos periodicamente. O uso contínuo do Serviço após tais alterações constitui sua aceitação dos novos Termos.
          </p>
        </div>
      </main>

      <footer className="landing-footer" style={{ marginTop: 'var(--space-12)' }}>
        <div className="landing-footer-bottom">
          <div className="landing-copyright">
            © {new Date().getFullYear()} Lictor. Todos os direitos reservados.
          </div>
        </div>
      </footer>
    </div>
  );
}
